import * as React from 'react';

const RocketSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="rocket_svg__eds-icon--tech_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="rocket_svg__eds-icon--tech_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M20 21v-5h-2V8c0-1.8-.8-3.5-2.2-4.6C14.7 2.5 13.4 2 12 2s-2.7.5-3.8 1.4C6.8 4.5 6 6.2 6 8v8H4v5H3v1h3v-1H5v-4h1v3h3v2h6v-2h3v-3h1v4h-1v1h3v-1h-1zM8.8 4.2c.9-.8 2-1.2 3.2-1.2s2.3.4 3.2 1.2c.9.7 1.5 1.7 1.7 2.8H7.1c.2-1.1.8-2.1 1.7-2.8zM10 21h4v-1h-4v1zm7-2H7v-2h1v-1H7V8h10v8h-1v1h1v2z"
        />
        <path
            id="rocket_svg__eds-icon--tech_circle"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M12 10c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
        />
    </svg>
);

RocketSvg.displayName = 'RocketSvg';
export default RocketSvg;
